import axiosInstance from './axiosInstance';

// Fetches the driver's payments, optionally filtered by a date range.
// If no dates are passed, the backend defaults to the current week.
export async function getPayments(from, to, page = 1, limit = 10) {
  const params = { page, limit };
  if (from) params.from = from;
  if (to) params.to = to;

  const response = await axiosInstance.get('/payments/get-payments.php', { params });
  return response.data;
}





// Fetches full details for a single payment.
export async function getPayment(id) {
  const response = await axiosInstance.get(`/payments/get-payment-detail.php?id=${id}`);
  return response.data;
}





